export const CREATE_VTPARAMMAP = 'CREATE_VTPARAMMAP'
export const SAVED_VTPARAMMAP = 'SAVED_VTPARAMMAP'

export const EDIT_VTPARAMMAP = 'EDIT_VTPARAMMAP'
export const EDITED_VTPARAMMAP = 'EDITED_VTPARAMMAP'

export const FETCH_VTPARAMMAP = 'FETCH_VTPARAMMAP'
export const FETCHED_VTPARAMMAP = 'FETCHED_VTPARAMMAP'

export const SEARCH_VTPARAMMAP = 'SEARCH_VTPARAMMAP'
export const STORE_SEARCH_VTPARAMMAP_RESULT = 'STORE_SEARCH_VTPARAMMAP_RESULT'

export const DELETE_VTPARAMMAP = 'DELETE_VTPARAMMAP'
export const DELETED_VTPARAMMAP = 'DELETED_VTPARAMMAP'

export const NOTIFICATION_DONE_VTPARAMMAP = 'NOTIFICATION_DONE_VTPARAMMAP'
export const FILTER_ITEMS = 'FILTER_ITEMS'

export const SET_ROW_INDEX_VTPARAMMAP = 'SET_ROW_INDEX_VTPARAMMAP'
